<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>Analitico</h4>
        </div>
      </div>
    </div>

    <table class="table table-bordered">
      <thead>
        <tr>
          <th class="text-truncate">Canal</th>
          <th class="text-truncate">Campanha</th>
          <th class="text-truncate">Visualizações</th>
          <th class="text-truncate">Cliques</th>
          <th class="text-truncate">Conversões</th>
          <th class="text-truncate">Contratações</th>
          <th class="text-truncate">Taxa de conversão</th>
          <th class="text-truncate">Taxa de rejeição</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row">Job Board</th>
          <th scope="row">Indeed</th>
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>3</td>
          <td>20%</td>
          <td>20%</td>
        </tr>
        <tr>
          <th scope="row">Job Board</th>
          <th scope="row">Indeed</th>
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>3</td>
          <td>20%</td>
          <td>20%</td>
        </tr>
        <tr>
          <th scope="row">Social</th>
          <th scope="row">Indeed</th>
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>3</td>
          <td>20%</td>
          <td>20%</td>
        </tr>
        <tr>
          <th scope="row">Social</th>
          <th scope="row">Indeed</th>
          <td>1</td>
          <td>2</td>
          <td>3</td>
          <td>3</td>
          <td>20%</td>
          <td>20%</td>
        </tr>
      </tbody>
    </table>

  </div>

</template>

<script>

export default {
  name: 'ReportPostingAnalytic',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
  },
  watch: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Report/ReportPostingAnalytic.vue